module.exports = "/_next/static/images/ca500a3b70574d0a06c50de2b7078f88-open-graph-experiment.jpg";